import { orderBy } from 'lodash';
import { TableSort } from '@eas/common-web';

export const emissionsTradingValueMapper = function emissionsTradingValueMapper({
  value,
  sorts,
}: {
  value: string[];
  sorts: TableSort[];
}) {
  const sort = sorts.find((s) => s.datakey === 'emissionsTradingSystem.ids');
  const order = sort?.order === 'ASC' ? 'asc' : 'desc';

  const sortedPids = orderBy(value, (pid) => pid, [order]);

  return sortedPids.join(', ');
};

emissionsTradingValueMapper.displayName = 'emissionsTradingValueMapper';
